var axios;
var constants;
require('es6-promise').polyfill();
axios = require('axios');
constants = require('./constants.js');

function DealerService(endpoint) {
  this.endpoint = endpoint;
}

DealerService.prototype.fetchDealers = function fetchDealers(opts) {
  var args = '';

  if (opts) {
    Object.keys(opts).forEach(function tet(key) {
      args += '&' + key + '=' + opts[key];
    });
  }

  if (window.dealerLocator.configGUID) {
    args += '&' + constants.global.CONFIG_GUID_PARAM + '=' + window.dealerLocator.configGUID;
  }

  return axios.get(this.endpoint + args)
    .then(function responseHandler(response) {
      return response.data;
    })
    .catch(function responseHandler(error) {
      var redirect = window.dealerLocator && window.dealerLocator.errorRedirect
        ? window.dealerLocator.errorRedirect : false;
      // eslint-disable-next-line no-console
      console.log('Endpoint Error', error);
      if (redirect) {
        document.location.assign(redirect);
      }
      return null;
    });
};

module.exports = DealerService;
